import React, { Fragment, PureComponent } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";
// import moment from "moment";
// import ScrollMenu from "react-horizontal-scrolling-menu";
// import parse from "html-react-parser";

class InfoLeftTab1 extends PureComponent {
  state = {};
  _renderItem = () => {
    const { timeLineList } = this.props.childProps;

    const list = timeLineList.map((item, index) => {
      return (
        <li key={index}>
          <div className="time">{item.outputStart.substr(0, 5)}</div>
          <p className="subject">{item.title}</p>
          <p className="epi">{item.subTitle}</p>
        </li>
      );
    });

    return list;
  };
  _timeline = () => {
    const { setTimeline } = this.props;
    //setTvline(false)
    setTimeline(true);
  };
  render() {
    const { timeLineList, title, subTitle, outputStart, outputEnd, ratio } =
      this.props.childProps;
    return (
      <Fragment>
        <div className="live_list show now">
          <div className="tit">
            <b>NOW</b>
          </div>
          <ul>
            <li>
              <p className="subject">{title}</p>
              <p className="epi">{subTitle}</p>
              <div className="player">
                <span className="time">{outputStart.substr(0, 5)}</span>
                <span className="bar">
                  <em style={{ width: ratio + "%" }}></em>
                </span>
                <span className="time">{outputEnd.substr(0, 5)}</span>
              </div>
            </li>
          </ul>
        </div>
        <div className="live_list timeline">
          <ul>
            {timeLineList ? this._renderItem() : null}
            {/*
                            <li>
                                <div className="time">13:00</div>
                                <p className="subject">괴병의 라무네</p>
                                <p className="epi">19화 엘리오르 대삼림의 영구동토 엘리오르 대삼림의 영구동토</p>
                            </li>
                            <li>
                                <div className="time">13:00</div>
                                <p className="subject">괴병의 라무네</p>
                                <p className="epi">19화 엘리오르 대삼림의 영구동토</p>
                            </li>
                            <li>
                                <div className="time">13:00</div>
                                <p className="subject">괴병의 라무네</p>
                                <p className="epi">19화 엘리오르 대삼림의 영구동토</p>
                            </li>
                            <li>
                                <div className="time">13:00</div>
                                <p className="subject">괴병의 라무네</p>
                                <p className="epi">19화 엘리오르 대삼림의 영구동토</p>
                            </li>
                            <li>
                                <div className="time">13:00</div>
                                <p className="subject">괴병의 라무네</p>
                                <p className="epi">19화 엘리오르 대삼림의 영구동토</p>
                            </li>
                            <li>
                                <div className="time">13:00</div>
                                <p className="subject">괴병의 라무네</p>
                                <p className="epi">19화 엘리오르 대삼림의 영구동토</p>
                            </li>
                            <li>
                                <div className="time">13:00</div>
                                <p className="subject">괴병의 라무네</p>
                                <p className="epi">19화 엘리오르 대삼림의 영구동토</p>
                            </li>
                            <li>
                                <div className="time">13:00</div>
                                <p className="subject">괴병의 라무네</p>
                                <p className="epi">19화 엘리오르 대삼림의 영구동토</p>
                            </li>
                            <li>
                                <div className="time">13:00</div>
                                <p className="subject">괴병의 라무네</p>
                                <p className="epi">19화 엘리오르 대삼림의 영구동토</p>
                            </li>
                            <li>
                                <div className="time">13:00</div>
                                <p className="subject">괴병의 라무네</p>
                                <p className="epi">19화 엘리오르 대삼림의 영구동토</p>
                            </li>
                            */}
            <div className="btn_wrap">
              <button
                type="button"
                className="btn_timeline"
                onClick={this._timeline}
              >
                LIVE 편성표
              </button>
            </div>
          </ul>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(InfoLeftTab1));
